import { Loader } from 'braid-design-system';
import React from 'react';

import type { RenderVariant } from '../utils/typeUtils';

import { ProfileActionsLoggedIn } from './ProfileActionsLoggedIn';
import { ProfileActionsLoggedOut } from './ProfileActionsLoggedOut';

interface ProfileActionsProps {
  variant: RenderVariant;
  baseUrl: string;
  advertiserCentreUrl: string;
}

export const ProfileActions = ({
  variant,
  baseUrl,
  advertiserCentreUrl,
}: ProfileActionsProps) => {
  if (variant === 'logged-out') {
    return <ProfileActionsLoggedOut baseUrl={baseUrl} />;
  } else if (variant === 'logged-in-loading') {
    return (
      <Loader
        data={{ testid: 'desktop-navigation-header-profile-dropdown-loader' }}
        size="xsmall"
        delayVisibility
      />
    );
  }
  return (
    <ProfileActionsLoggedIn
      variant={variant}
      baseUrl={baseUrl}
      advertiserCentreUrl={advertiserCentreUrl}
    />
  );
};
